module.exports = __webpack_public_path__ + "img/background-upgrade-card.c6388d58.png";